export const b2bBreadCrumbSchema = {
  "@context": "https://schema.org/",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://onsitego.com/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "B2B Partner",
      item: "https://onsitego.com/b2b",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Onsitego for Business",
      item: "https://onsitego.com/b2b/landingpage",
    },
  ],
};

export const b2bOrganizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Onsitego",
  url: "https://onsitego.com/",
  logo: "https://d2js0267gg4oqb.cloudfront.net/_next/static/media/onsite-logo-inverse.8190a3419a1359a4a0b5ff4aa42b6dfe.png",
  sameAs: [
    "https://facebook.com/onsitego",
    "https://twitter.com/onsitego",
    "https://www.instagram.com/onsitego/",
    "https://www.youtube.com/c/Onsitego_official",
    "https://www.linkedin.com/company/onsitego",
  ],
};

export const banners = {
  banner1: {
    name: "AC AMC for Offices",
    desktop_image: "/static/images/b2b/landingpage/b2b_desktop_1.webp",
    tablet_image: "/static/images/b2b/landingpage/b2b_tablet_1.webp",
    mobile_image: "/static/images/b2b/landingpage/b2b_mobile_1.webp",
    dimensions: {
      desktop: { width: 1920, height: 790 },
      tablet: { width: 1280, height: 520 },
      mobile: { width: 960, height: 360 },
    },
  },
  banner2: {
    name: "Contact Us",
    desktop_image: "/static/images/b2b/landingpage/b2b_desktop_2.webp",
    tablet_image: "/static/images/b2b/landingpage/b2b_tablet_2.webp",
    mobile_image: "/static/images/b2b/landingpage/b2b_mobile_2.webp",
    dimensions: {
      desktop: { width: 1920, height: 680 },
      tablet: { width: 1280, height: 520 },
      mobile: { width: 960, height: 360 },
    },
  },
};
